import React, { useEffect, useState } from 'react';
import { Button } from 'antd';
import { SafetyCertificateOutlined } from '@ant-design/icons';
import { OPEN_PRIVACY_EVENT } from './template/Footer';

const STORAGE_KEY = 'datatek_rm_privacy_notice';
const STORAGE_VERSION = 1;
const GDPR_URL = 'https://www.datatek.sk/sk/gdpr';

const readAck = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== STORAGE_VERSION || !parsed.acknowledged) return null;
    return parsed;
  } catch {
    return null;
  }
};

const writeAck = () => {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      version: STORAGE_VERSION,
      acknowledged: true,
      updatedAt: new Date().toISOString(),
    }),
  );
};

/**
 * Toast vpravo dole pre Request Manager — nezaniká sám, čaká na potvrdenie.
 * Žiadna analytika ani marketing — len nevyhnutné session cookies.
 */
const PrivacyNotice = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!readAck()) setOpen(true);
  }, []);

  useEffect(() => {
    const onOpen = () => setOpen(true);
    window.addEventListener(OPEN_PRIVACY_EVENT, onOpen);
    return () => window.removeEventListener(OPEN_PRIVACY_EVENT, onOpen);
  }, []);

  const acknowledge = () => {
    writeAck();
    setOpen(false);
  };

  if (!open) return null;

  return (
    <aside
      className="privacy-notice-toast"
      role="dialog"
      aria-modal="false"
      aria-labelledby="privacy-notice-title"
      aria-live="polite"
    >
      <div className="privacy-notice-toast__panel">
        <div className="privacy-notice-toast__title" id="privacy-notice-title">
          <SafetyCertificateOutlined />
          Informácia o súkromí
        </div>
        <p className="privacy-notice-toast__lead">
          Request Manager je klientsky portál na evidenciu IT požiadaviek.
          Nevyužívame reklamu, marketingové cookies ani analytiku tretích strán.
        </p>
        <ul className="privacy-notice-toast__list">
          <li>
            <strong>Session cookie</strong> — prihlásenie a oprávnenia (nevyhnutné).
          </li>
          <li>
            <strong>Preferencie</strong> — zapamätanie tohto potvrdenia.
          </li>
          <li>
            Údaje v požiadavkách spracúvame podľa GDPR na plnenie zmluvy o podpore.
          </li>
        </ul>
        <p className="privacy-notice-toast__more">
          Viac v{' '}
          <a href={GDPR_URL} target="_blank" rel="noopener noreferrer">
            zásadách ochrany osobných údajov
          </a>
          .
        </p>
        <Button type="primary" block onClick={acknowledge}>
          Rozumiem
        </Button>
      </div>
    </aside>
  );
};

export default PrivacyNotice;
